import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { getClientData, saveClient, getClientPoints } from '../firebase/obj/client'
import { saveOrder, updateOrder } from '../firebase/obj/order'
import ClientOrderForm from '../components/order/orderForm/client'
import { navigate } from '@reach/router'
import { validateOrder, minimizeProduct } from '../utils/productEdit'
import { getClientAdressesRealTime, saveAddress, updateAddress } from '../firebase/obj/clientAddress'
import AddressForm from '../components/client/addressForm'
import useMainContext from '../hooks/useMainContext'
import useZoneContext from '../hooks/useZoneContext'
import { isPointInsideZone } from '../utils'
import { calculateTotalOrder } from '../utils/order'
import { getCurrentUser } from '../firebase/obj/user' // Added for fetching token

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Deep clean for Firestore (remove undefined values)
const cleanFirestoreData = (obj) => {
    if (obj === null || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(cleanFirestoreData).filter(v => v !== undefined);
    
    const cleaned = {};
    Object.entries(obj).forEach(([k, v]) => {
        if (v !== undefined) {
            cleaned[k] = cleanFirestoreData(v);
        }
    });
    return cleaned;
}

export const CartWithData = ({ cart, setCart = () => { } }) => {
    const { user, paymentMethods, config, businessInfo } = useMainContext() // Added businessInfo
    const [notification, setNotification] = useState({})
    const [order, setOrder] = useState({ createdByClient: true, productsList: [], pickup: false })
    const [client, setClient] = useState(null)
    const [mercadopagoPreferenceId, setMercadopagoPreferenceId] = useState(null) // MP Preference ID
    const [showMercadoPagoBackdrop, setShowMercadoPagoBackdrop] = useState(false)
    const [clientPoints, setClientPoints] = useState(0)
    const [openAddressForm, setOpenAddressForm] = useState(false)
    const [addresses, setAddresses] = useState([])
    const { zones } = useZoneContext()

    useEffect(() => {
        //console.log('paymentMethod', paymentMethods, cart)
        if (paymentMethods?.length === 1 && cart && !cart.paymentMethod) {
            const paymentMethod = paymentMethods[0].method
            //console.log('paymentMethod', paymentMethod)
            setCart({ ...cart, paymentMethod })
        }
    }, [paymentMethods, cart])

    useEffect(() => {
        let addressId = cart.addressId
        if (addressId)
            return


        setOrder({
            ...order,
            addressId
        })
    }, [addresses, cart])

    useEffect(() => {
        const fetchClientData = async () => {
            let { productsList = [], addressId, paymentMethod = '', pickup = false, position = [], address = '' } = cart
            let { firstClientState = 'Pendiente', deliveryPrice = 0 } = config || {}
            // console.log('user', user)
            if (cart.deliveryPrice) {
                deliveryPrice = cart.deliveryPrice
            }
            if (client) {
                // console.log('client', client)
                const { name, email, id, phone = (user?.phoneNumber || '') } = client
                // console.log('phone', phone)
                const addressInfo = addresses.find(e => addressId === e.id) || {}
                if (addressInfo?.position && addressInfo?.address) {
                    position = addressInfo.position
                    address = `${addressInfo.address} ${addressInfo.number}`
                }
                const zone = isPointInsideZone(position, zones)
                const zoneId = zone?.id || ''
                if (zone) {
                    deliveryPrice = Number(zone.price)
                }
                // console.log('addressInfo', addressInfo)
                // console.log('zones', zones)
                // console.log('zone', zone)
                // console.log('deliveryPrice', deliveryPrice)
                const _order = {
                    ...order,
                    zoneId,
                    clientId: id,
                    clientName: name,
                    clientPhone: phone,
                    userEmail: email,
                    addressId,
                    address,
                    position,
                    productsList,
                    orderState: firstClientState,
                    deliveryPrice,
                    usedPoints: cart.usedPoints,
                    paymentMethod,
                    pickup
                }

                const { total, pickupDiscount, totalSavings } = calculateTotalOrder({ ..._order, config })
                return setOrder({
                    ..._order,
                    amount: total,
                    pickupDiscount,
                    totalSavings
                })
            }
            if (!user) {

                const _order = {
                    ...order,
                    productsList,
                    orderState: firstClientState,
                    deliveryPrice,
                    usedPoints: cart.usedPoints
                }
                const { total, pickupDiscount, totalSavings } = calculateTotalOrder({ ..._order, config })
                return setOrder({
                    ..._order,
                    amount: total,
                    pickupDiscount,
                    totalSavings
                })
            }

            getClientPoints(user.uid).then(data => {
                setClientPoints(data.points || 0)
            })

            return getClientData(user.uid).then(client => {
                const { name, email, id, phone } = client
                setClient(client)
                const _order = {
                    ...order,
                    clientId: id,
                    clientName: name,
                    clientPhone: phone,
                    userEmail: email,
                    addressId,
                    productsList,
                    orderState: firstClientState,
                    deliveryPrice,
                    usedPoints: cart.usedPoints,
                    paymentMethod,
                    pickup
                }
                getClientAdressesRealTime(user.uid, setAddresses)
                const { total, pickupDiscount, totalSavings } = calculateTotalOrder({ ..._order, config })
                setOrder({
                    ..._order,
                    amount: total,
                    pickupDiscount,
                    totalSavings
                })
            })
        }

        fetchClientData()

    }, [user, config, cart, zones])


    /**
     * Called when product qty changes or adds a new product
     */
    const setProductQty = (product, qty) => {
        let totalQty = 0

        if (qty < 1) qty = 0

        const productsList = cart.productsList?.map(item => {
            if (item.id === product.id) {
                totalQty += qty
                return { ...product, qty }
            }
            totalQty += item.qty

            return item
        }).filter(p => Number(p.qty) > 0)

        setCart({ ...cart, productsList, totalQty })
    }


    const updateClient = (order) => {
        if (!user || !user.uid) return; // Do not proceed if user is not available
        getClientData(user.uid).then(client => {
            const { name, address, phone, id, position } = client

            if (!name || !address || !phone || !position) {

                client.id = id || user.uid
                client.name = name || order.client || order.clientName
                client.address = address || order.address
                client.phone = phone || order.phone || order.clientPhone
                client.position = position || order.position

                saveClient(client)
            }
        })

    }

    const fetchMercadoPagoPreferenceId = async (currentOrder) => {
        setShowMercadoPagoBackdrop(true);

        if (!user) {
            setNotification({
                open: true,
                autoHideDuration: 5000,
                severity: 'error',
                message: 'Debes iniciar sesión para pagar con Mercado Pago.',
            });
            throw new Error('User not logged in for Mercado Pago payment.');
        }

        try {
            const token = await getCurrentUser()?.getIdToken();
            if (!token) {
                throw new Error('Authentication token not found.');
            }

            // First, save the order to get an orderId if it's a new order
            // Assuming saveOrder returns the ID and potentially the saved order data
            // If the order is already saved and we are just creating preference, this logic might need adjustment
            // For now, let's assume we always save/update the order to a "pending payment" first.
            const orderToSave = cleanFirestoreData({
                ...currentOrder,
                orderState: 'Pago pendiente', // Or a similar state
                paymentMethod: 'mercadopago', // Ensure it's set
                productsList: currentOrder.productsList.map(p => minimizeProduct(p))
            });

            console.log('Order to save (Mercado Pago):', orderToSave);
            const orderId = await saveOrder(orderToSave); // Save order and get ID

            updateClient(orderToSave); // Update client info
            setOrder({
                ...orderToSave,
                id: orderId
            })

            const preferencePayload = {
                orderId: orderId, // Use the ID from the saved order
                userId: user.uid,
                amount: parseFloat(Number(currentOrder?.amount || 0).toFixed(2)), // Ensure amount is a number
                currency_id: businessInfo?.currency?.code || "UYU", // Get currency from businessInfo or default
                description: `Compra en ${process.env.REACT_APP_NAME || businessInfo?.companyName || 'tu tienda'}`,
                // items: currentOrder.productsList.map(p => ({ // This was not in the user-provided example, but MP usually needs it
                //     id: p.id,
                //     title: p.name,
                //     quantity: p.qty,
                //     unit_price: parseFloat(p.pricetoFixed(2)),
                //     currency_id: businessInfo?.currency?.code || "UYU",
                // })),
                // external_reference: orderId, // Good practice to link MP payment to your order
            };

            // console.log("Sending to backend for preference ID:", preferencePayload);

            const response = await fetch(`${API_BASE_URL}/mercadopago/preference/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(preferencePayload),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Error creating Mercado Pago preference:', errorData);
                throw new Error(errorData.message || 'Error al crear la preferencia de pago.');
            }

            const data = await response.json();

            if (data.initPoint) {
                // Redirect the user to Mercado Pago's checkout page
                window.location.href = data.initPoint;
            } else {
                setShowMercadoPagoBackdrop(false);
                throw new Error('initPoint no recibido del backend.');
            }

        } catch (error) {
            setShowMercadoPagoBackdrop(false);
            console.error('fetchMercadoPagoPreferenceId error:', error);
            setNotification({
                open: true,
                autoHideDuration: 5000,
                severity: 'error',
                message: error.message || 'No se pudo generar la preferencia de pago.',
            });
            throw error;
        }
    };


    const handleSendOrder = async (order) => {
        // Clear any previous preference ID when a new order process starts
        setMercadopagoPreferenceId(null);

        try {
            // Make a mutable copy of the order from state for modifications
            let _order = { ...order };
            _order.clientName = _order.clientName?.toUpperCase();
            _order.userEmail = user?.email; // Ensure user exists
            _order.createdByClient = true;

            if (!_order.usedPoints) {
                _order.usedPoints = 0;
            }

            if (_order.pickup) {
                _order.addressId = '';
                _order.address = '';
                _order.position = [];
            } else {
                const addressInfo = addresses.find(e => _order.addressId === e.id) || {};
                _order.address = `${addressInfo.address}${addressInfo.number ? ` ${addressInfo.number}` : ''}`;
                _order.position = addressInfo.position;
            }

            // Recalculate amount just in case, ensuring it's part of _order passed around
            const { total, pickupDiscount, totalSavings } = calculateTotalOrder({ ..._order, config })
            _order.amount = total
            _order.pickupDiscount = pickupDiscount
            _order.totalSavings = totalSavings


            const validation = validateOrder(_order, paymentMethods);
            if (!validation.valid) {
                setNotification({
                    open: true,
                    autoHideDuration: 3000,
                    severity: validation.severity || 'warning',
                    message: validation.message,
                });
                return
            }



            if (_order.paymentMethod === 'mercadopago') {
                await fetchMercadoPagoPreferenceId(_order);
                // The flow stops here for MP, Brick takes over.
                // `fetchMercadoPagoPreferenceId` already saved the order as "pending payment".
                return;
            }



            // For other payment methods (e.g., cash, or Polarsh which is handled in ClientOrderForm)
            const orderToSave = cleanFirestoreData({
                ..._order,
                productsList: _order.productsList.map(p => minimizeProduct(p))
            });
            console.log('Order to save (Normal):', orderToSave);
            const id = await saveOrder(orderToSave); // This saves the order for non-MP payments
            updateClient(orderToSave);
            setCart({ productsList: [], totalQty: 0, addressId: null, paymentMethod: null, usedPoints: 0 });

            if (_order.paymentMethod !== 'polarsh') { // Polarsh handles its own navigation/notification
                setNotification({
                    open: true,
                    autoHideDuration: 3000,
                    severity: 'success',
                    message: 'Pedido enviado!',
                });
                setTimeout(() => {
                    navigate(`/order/${id}`);
                }, 3000);
            }
            return id;

        } catch (error) {
            console.error('handleSendOrder error:', error);
            setNotification({
                open: true,
                autoHideDuration: 3000,
                severity: 'error',
                message: error.message,
            })
            throw error // Re-lanzar el error para que el código que llama pueda manejarlo
        }
    }

    const finalizeOrderAfterMP = async (mpPayment, orderId) => {
        // This function will be called from ClientOrderForm after MP processes payment
        try {


            const paymentStatus = mpPayment.status; // e.g., 'approved', 'pending', 'rejected'
            const mpPaymentId = mpPayment.payment_id || mpPayment.id; // Mercado Pago Payment ID

            let newOrderState = 'Pago pendiente';
            let notificationSeverity = 'warning';
            let notificationMessage = 'Tu pago está pendiente de confirmación.';
            let shouldClearCart = false;
            let redirectTo = `/order/${orderId}`; // Default redirect to order details

            if (paymentStatus === 'approved') {
                newOrderState = 'Pendiente'; // Or your equivalent status for a paid order
                notificationSeverity = 'success';
                notificationMessage = '¡Pago aprobado! Tu pedido ha sido confirmado.';
                shouldClearCart = true;
                redirectTo = `/mercadopago/success/${orderId}`;
            } else if (paymentStatus === 'rejected' || paymentStatus === 'cancelled' || paymentStatus === 'refunded' || paymentStatus === 'charged_back') {
                newOrderState = 'Pago rechazado (Mercado Pago)';
                notificationSeverity = 'error';
                notificationMessage = 'Tu pago fue rechazado. Por favor, intenta nuevamente o con otro medio de pago.';
                shouldClearCart = false; // Keep cart items so user can retry
                redirectTo = `/mercadopago/failure/${orderId}`;
            }
            // For 'in_process' or 'pending', we keep the order state as "pending" and notify the user.

            // Update the order in Firebase with the Mercado Pago payment details
            // We need a way to update an existing order. Let's assume saveOrder can handle updates if an ID is present.
            // Or we might need a specific updateOrder function. For now, assuming saveOrder can update.
            const orderUpdateData = {
                id: orderId, // Crucial for updating the correct order
                orderState: newOrderState,
                paymentDetails: { // Store MP payment info
                    mercadopagoPaymentId: mpPaymentId,
                    status: paymentStatus,
                    method: mpPayment.payment_method_id,
                    type: mpPayment.payment_type_id,
                    lastFourDigits: mpPayment.card?.last_four_digits, // if available
                },
                // We need to ensure we don't overwrite other essential order fields
                // So, it's better if saveOrder intelligently merges or we fetch the order first.
                // For simplicity here, we assume saveOrder can take partial data for an update,
                // or the backend handles merging based on orderId.
                // A safer approach would be:
                // 1. Fetch order by orderId
                // 2. Merge new payment details and state
                // 3. Call saveOrder with the full, updated order object.
                // This example will assume saveOrder can handle an update with {id, orderState, paymentDetails}.
            };

            await updateOrder(orderUpdateData); // Pass a flag if saveOrder needs to know it's an update

            setNotification({
                open: true,
                autoHideDuration: 7000,
                severity: notificationSeverity,
                message: notificationMessage,
            });

            if (shouldClearCart) {
                setCart({ productsList: [], totalQty: 0, addressId: null, paymentMethod: null, usedPoints: 0 });
                setMercadopagoPreferenceId(null); // Clear preference ID
            }

            navigate(redirectTo);

        } catch (error) {
            console.error('Error finalizing order after MP payment:', error);
            setNotification({
                open: true,
                autoHideDuration: 5000,
                severity: 'error',
                message: 'Hubo un error al finalizar tu pedido después del pago. Contacta a soporte.',
            });
            // Optionally navigate to a generic error page or order page
            if (orderId) {
                navigate(`/order/${orderId}`);
            } else {
                navigate('/cart');
            }
        }
    };

    const handleDeleteProduct = product => {
        const productsList = cart.productsList?.filter(p => p.id !== product.id)
        const totalQty = cart.totalQty - product.qty
        setCart({ ...cart, productsList, totalQty })
    }

    const usedPointsHandler = (order, usedPoints) => {
        setCart({ ...cart, ...order, usedPoints })
    }

    const setOrderAddress = clientAddress => {
        const { id, address, number, phone, position } = clientAddress
        setCart({ ...cart, addressId: id, address: `${address} ${number}`, phone, position })
    }

    const handleSaveAddress = (data, onError = () => { }) => {
        // console.log('handleSaveAddress', user.uid, data)
        const { id } = data
        if (id)
            updateAddress(user.uid, data)
                .then(() => {
                    setOpenAddressForm(false)
                    setOrderAddress(data)
                })
                .catch(onError)

        saveAddress(user.uid, data)
            .then(({ id }) => {
                setOpenAddressForm(false)
                setOrderAddress({ ...data, id })
            })
            .catch(onError)
    }

    const setOrderHandler = (order) => {
        const { addressId, productsList } = order
        // const amount = calculateTotalOrder(order)
        // console.log('amount', amount)
        // order.amount = amount
        setOrder(order)
        setCart({ ...order, addressId, productsList })
    }

    return (
        <>
            <Backdrop open={showMercadoPagoBackdrop} style={{ zIndex: 9999, color: '#fff' }}>
                <CircularProgress color="inherit" />
                <h4 style={{ marginLeft: 15 }}>Redirigiendo a Mercado Pago...</h4>
            </Backdrop>
            <AddressForm
                selected={{ principal: (addresses.length === 0), id: '', position: [] }}
                openForm={openAddressForm}
                setOpenForm={setOpenAddressForm}
                saveAddress={handleSaveAddress}
                config={config}
            />
            <ClientOrderForm
                user={user}
                client={client}
                order={order} // This order object now contains the live amount, paymentMethod etc.
                notification={notification}
                setOrder={setOrderHandler} // Used for general order updates by ClientOrderForm
                setNotificationOpen={setNotification}
                setProductQty={setProductQty}
                sendOrder={handleSendOrder} // Still used for non-MP payment submissions & to trigger MP pref ID fetch
                deleteProduct={handleDeleteProduct}
                clientPoints={clientPoints}
                usedPointsHandler={usedPointsHandler}
                addresses={addresses}
                setOpenAddressForm={setOpenAddressForm}
                paymentMethods={paymentMethods}
                mercadopagoPreferenceId={mercadopagoPreferenceId} // Pass the preference ID
                finalizeOrderAfterMP={finalizeOrderAfterMP} // Pass the finalization function
                clearMercadoPagoPreferenceId={() => setMercadopagoPreferenceId(null)} // To clear if user navigates away or cancels
            />
        </>
    )
}

export default CartWithData